export const getSelfBreastDetails = (baseKey: string): 'pathology.breast.bilateralDetails' | 'pathology.breast.details' => {
  if (baseKey.endsWith('left') || baseKey.endsWith('right')) {
    return 'pathology.breast.bilateralDetails';
  } else {
    return 'pathology.breast.details';
  }
};

export const getRelativeBreastDetails = (baseKey: string): 'pathology.breast.detailsBilateralRelative' | 'pathology.breast.detailsRelative' => {
  if (baseKey.endsWith('first') || baseKey.endsWith('second')) {
    return 'pathology.breast.detailsBilateralRelative';
  } else {
    return 'pathology.breast.detailsRelative';
  }
};
